<button class="ai-chat-fab btn btn-primary btn-icon" type="button" aria-label="Open AI assistant"
  [attr.aria-expanded]="state.open()" aria-controls="global-ai-chat-panel" (click)="toggle()">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
    class="icon icon-tabler icons-tabler-outline icon-tabler-robot">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -4" />
    <path d="M12 2v2" />
    <path d="M9 12v9" />
    <path d="M15 12v9" />
    <path d="M5 16l4 -2" />
    <path d="M15 14l4 2" />
    <path d="M9 18h6" />
    <path d="M10 8v.01" />
    <path d="M14 8v.01" />
  </svg>
</button>

<section id="global-ai-chat-panel" class="ai-chat-popover card" role="dialog" aria-label="AI assistant"
  *ngIf="state.open()">
  <header class="card-header d-flex align-items-center gap-2">
    <button type="button" class="btn btn-icon btn-ghost-secondary" aria-label="Back to conversations"
      *ngIf="!showConversationList" (click)="backToConversationList()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" /></svg></button>
    <span class="avatar avatar-sm bg-primary-lt text-primary ai-chat-avatar" aria-label="AI assistant">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="icon icon-tabler icons-tabler-outline icon-tabler-robot" aria-hidden="true">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -4" />
        <path d="M12 2v2" />
        <path d="M9 12v9" />
        <path d="M15 12v9" />
        <path d="M5 16l4 -2" />
        <path d="M15 14l4 2" />
        <path d="M9 18h6" />
        <path d="M10 8v.01" />
        <path d="M14 8v.01" />
      </svg>
    </span>
    <div class="min-width-0 flex-fill"><strong>{{ showConversationList ? 'Conversations' : 'AI assistant' }}</strong>
      <div class="text-secondary small text-truncate">{{ showConversationList ? 'Choose a conversation or start a new one' : 'Ask about your ERP data' }}</div>
    </div>
    <button type="button" class="btn btn-icon btn-ghost-secondary btn-pill" aria-label="Minimize AI assistant"
      title="Minimize" (click)="state.close()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 9l6 6l6 -6" /></svg></button>
  </header>
  <div class="alert alert-danger m-2" *ngIf="state.error()">{{ state.error() }}</div>
  <app-ai-conversation-list *ngIf="showConversationList" [compact]="true"
    (newConversation)="startConversation()"
    (conversationSelected)="openConversation($event)"></app-ai-conversation-list>
  <div class="ai-chat-thread" *ngIf="!showConversationList">
    <div class="empty py-5" *ngIf="!state.loading() && state.messages().length === 0">
      <p class="empty-title">How can I help?</p>
      <p class="empty-subtitle">Ask a question or request a report graph.</p>
    </div>
    <app-ai-message *ngFor="let item of state.messages()" [message]="item" [compact]="true"></app-ai-message>
    <div class="text-secondary small" *ngIf="state.sending()">The assistant is working…</div>
    <div class="ai-system-notice" role="status" *ngIf="state.quotaError()">
      <span class="ai-system-icon"><i class="ti ti-clock-exclamation"></i></span>
      <div><strong>Provider limit reached</strong><span class="d-block">{{ state.quotaError() }}</span></div>
    </div>
  </div>
  <app-ai-composer *ngIf="!showConversationList || state.setupRequired()" mode="popover" [(message)]="message" [busy]="state.sending()"
    (submitted)="send($event)"></app-ai-composer>
</section>
